var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sfcNodeTypeContent" },
    _vm._l(
      _vm.dialogData.nodeDataList.productStationTraceList,
      function (group, groupIndex) {
        return _c("div", { key: groupIndex, staticClass: "sfcNodeTypeGroup" }, [
          _c(
            "div",
            {
              staticClass: "sfcNodeTypeGroupName",
              staticStyle: { "font-weight": "bold" },
            },
            [_vm._v(_vm._s(group.sequence))]
          ),
          _c(
            "div",
            { staticClass: "sfcNodeTypeList" },
            _vm._l(_vm.getItemDataList(group), function (type, typeIndex) {
              return _c(
                "div",
                {
                  key: typeIndex,
                  staticClass: "sfcNodeTypeItem",
                  on: {
                    click: function ($event) {
                      return _vm.onNodeTypeClick(type, group)
                    },
                  },
                },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(type.itemName) + ":" + _vm._s(type.itemValue)
                    ),
                  ]),
                  _c("div", [
                    _vm._v(
                      "采集时间:" +
                        _vm._s(
                          _vm.$$formatDate(
                            type.collectTime,
                            "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}"
                          )
                        )
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ])
      }
    ),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }